module.exports = __webpack_public_path__ + "img/data3.85132386.png";